import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      user: this.$store.state.user,
      current: this.$route.path,
      company_full: this.$store.state.company_full,
      items: [],
      currentUser: false,
      today: false,
      yesterDay: false,
      messageCount: null,
      userNameCount: null,
      charCount: null,
    };
  },
  created() {
    this.$axios
      .get(baseUrl + "/notificationsoverview?mini")
      .then((response) => {
        this.items = response.data;
        if (this.items.length >= 4) {
          this.items.length = 4;
        }
        this.setUser(this.items);
        this.setCharAmount(this.items);

        if (this.items[0]) {
          if (
            this.items[0].id !=
            localStorage.getItem(
              this.company_full.name + "_last-notification-checked"
            )
          ) {
            EventBus.$emit("show-notification-dot");
          }
        }
      });

    EventBus.$on("notifications-checked", (callback) => {
      if (this.items[0]) {
        localStorage.setItem(
          this.company_full.name + "_last-notification-checked",
          this.items[0].id
        );
      }
    });
  },
  methods: {
    openItem(itemId, sort, folderId) {
      if (itemId == null) {
        return;
      }
      if (sort === "foldercreate") {
        this.$router.push(
          "/" + this.$store.state.company + "/home/expanded/" + itemId
        );
        this.$router.go();
      }
      if (sort === "fileupload") {
        this.$router.push(
          "/" +
            this.$store.state.company +
            "/home/expanded/" +
            folderId +
            "?file=" +
            itemId
        );
        this.$router.go();
      }
    },
    /**
     * Check if the changes where made by the current user
     * @param items
     */
    setUser(items) {
      items.forEach((item, index) => {
        if (this.user != null && item.user_name == this.user.name) {
          this.items[index].current = true;
        } else {
          this.items[index].current = false;
        }
      });
    },
    /**
     * Count the characters of the displayed message
     * -- If it is the current user only count the message
     * -- Else count the username and the message
     *
     * @param items
     */
    setCharAmount(items) {
      items.forEach((item, index) => {
        if (item.current) {
          this.charCount = item.message.length;
          this.items[index].char_amount = this.charCount;
        } else {
          this.userNameCount = item.user_name.length;
          this.messageCount = item.message.length;
          this.charCount = this.userNameCount + this.messageCount;
          this.items[index].char_amount = this.charCount;
          this.items[index].other_message = item.user_name + " " + item.message;
        }
      });
    },
    /**
     * Route to the given path
     * @param route
     */
    goTo(route) {
      this.more = false;
      this.$router.push(route);
      this.show = false;
    },
  },
};
